var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TemplateModal',{attrs:{"text":_vm.text,"confirmLabel":"Ok","hideCancelBtn":true},on:{"onConfirm":_vm.lostAccess,"onClose":_vm.lostAccess}})}
var staticRenderFns = []

export { render, staticRenderFns }